module.exports = __webpack_public_path__ + "img/Data analyse.5ccdbbb5.png";